var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgListIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 28.248,
    height: 28.325,
    viewBox: "0 0 28.248 28.325",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_294",
    "data-name": "Rectangle 294",
    width: 28.248,
    height: 28.325,
    fill: "#015c7e"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_375",
    "data-name": "Groupe 375",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_348",
    "data-name": "Groupe 348",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2836",
    "data-name": "Trac\\xE9 2836",
    d: "M48.431,40.876a1.02,1.02,0,0,1-.871,1,3.139,3.139,0,0,1-.433.024q-3.755,0-7.516,0t-7.516,0a3.059,3.059,0,0,1-.465-.028,1.037,1.037,0,0,1,.093-2.052c.093-.007.186-.007.282-.007h9.661q2.814,0,5.636,0a1.163,1.163,0,0,1,.854.32,1.013,1.013,0,0,1,.276.744",
    transform: "translate(-20.183 -26.103)",
    fill: "#015c7e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2837",
    "data-name": "Trac\\xE9 2837",
    d: "M48.426,70.665a1.029,1.029,0,0,1-.95,1c-.069.007-.142.007-.214.007H31.928a1.214,1.214,0,0,1-.881-.331,1.044,1.044,0,0,1,.572-1.728,2.652,2.652,0,0,1,.468-.028q7.514-.005,15.028,0a3.224,3.224,0,0,1,.434.021,1.017,1.017,0,0,1,.878,1.06",
    transform: "translate(-20.179 -45.625)",
    fill: "#015c7e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2838",
    "data-name": "Trac\\xE9 2838",
    d: "M48.424,11.111a1.029,1.029,0,0,1-.968.978,1.556,1.556,0,0,1-.179.007H31.939a1.072,1.072,0,0,1-1.157-.926,1.02,1.02,0,0,1,.854-1.143A2.135,2.135,0,0,1,32.049,10H47.14a2.438,2.438,0,0,1,.4.021,1.031,1.031,0,0,1,.882,1.091",
    transform: "translate(-20.18 -6.556)",
    fill: "#015c7e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2839",
    "data-name": "Trac\\xE9 2839",
    d: "M10.083,30.786a1.213,1.213,0,0,1-.393.861c-.947.961-1.9,1.918-2.85,2.875L5.266,36.105c-.355.358-.706.713-1.06,1.067a1.181,1.181,0,0,1-.823.406,1.175,1.175,0,0,1-.816-.4C1.84,36.46,1.12,35.737.4,35.014a1.1,1.1,0,0,1-.3-1.284,1.061,1.061,0,0,1,.757-.589,1.046,1.046,0,0,1,.906.31c.361.348.712.7,1.064,1.057l.513.513,4.228-4.231c.21-.21.417-.42.63-.627a1.029,1.029,0,0,1,1.546-.1,1.014,1.014,0,0,1,.338.72",
    transform: "translate(0 -19.514)",
    fill: "#015c7e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2840",
    "data-name": "Trac\\xE9 2840",
    d: "M10.057,60.8a1.4,1.4,0,0,1-.344.658c-1.629,1.646-3.4,3.419-5.567,5.574a1.069,1.069,0,0,1-.754.351,1.1,1.1,0,0,1-.767-.355c-.7-.689-1.384-1.381-2.073-2.073l-.182-.179a1.035,1.035,0,0,1-.307-1.122,1.035,1.035,0,0,1,.727-.7,1.038,1.038,0,0,1,.967.289c.368.355.734.72,1.085,1.078l.347.351c.052.052.1.107.162.179a1.306,1.306,0,0,1,.138-.169q2.37-2.376,4.744-4.744a1.008,1.008,0,0,1,1.226-.258,1.075,1.075,0,0,1,.6,1.122",
    transform: "translate(-0.002 -39.06)",
    fill: "#015c7e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2841",
    "data-name": "Trac\\xE9 2841",
    d: "M10.081,1.019a1.126,1.126,0,0,1-.348.809c-.609.627-1.226,1.246-1.842,1.863L6.115,5.484c-.619.627-1.239,1.25-1.863,1.876a1.241,1.241,0,0,1-.861.448h0a1.243,1.243,0,0,1-.864-.444L2.1,6.94C1.529,6.369.954,5.8.386,5.222A1.037,1.037,0,0,1,.224,3.783a.991.991,0,0,1,.716-.427,1.069,1.069,0,0,1,.826.324c.351.337.7.685,1.04,1.029.158.162.32.324.482.485a.76.76,0,0,0,.059.055L7.726.867c.172-.172.344-.348.52-.516A1.036,1.036,0,0,1,9.747.3a1.011,1.011,0,0,1,.334.723",
    transform: "translate(-0.002 0)",
    fill: "#015c7e"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListIcon);
export default __webpack_public_path__ + "static/media/list-icon.e163c459addb7418ff47b283fd805502.svg";
export { ForwardRef as ReactComponent };